import React from "react";
import { alpha } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import ScheduleIcon from "@mui/icons-material/Schedule";
import WarningIcon from "@mui/icons-material/Warning";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StorefrontIcon from "@mui/icons-material/Storefront";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import { getTimeChipStyling } from "../../../../utils/style/orderStylingUtils";
import { DESIGN_TOKENS, ORDER_TYPES } from "../../../../types/order";

export const OrderTimeChip = ({
  order,
  dateString,
  theme,
  isMobile = false,
}) => {
  const styling = getTimeChipStyling(order, theme);
  const chipHeight = isMobile
    ? DESIGN_TOKENS.chipHeight.sm
    : DESIGN_TOKENS.chipHeight.md;
  const fontSize = isMobile
    ? DESIGN_TOKENS.fontSize.base
    : DESIGN_TOKENS.fontSize.sm;

  return (
    <Tooltip title={`Entregar até: ${dateString}`}>
      <Chip
        icon={<ScheduleIcon sx={{ fontSize: DESIGN_TOKENS.iconSize.sm }} />}
        label={`${dateString}h`}
        size="small"
        sx={{
          height: chipHeight,
          fontSize,
          bgcolor: styling.bgcolor,
          color: styling.color,
          fontWeight: styling.fontWeight,
          "& .MuiChip-icon": {
            color: styling.iconColor,
          },
        }}
        aria-label={`Horário de entrega: ${dateString}`}
      />
    </Tooltip>
  );
};

export const BlacklistWarningChip = ({ theme, isMobile = false }) => {
  const chipHeight = isMobile
    ? DESIGN_TOKENS.chipHeight.sm - 2
    : DESIGN_TOKENS.chipHeight.md;
  const fontSize = isMobile
    ? DESIGN_TOKENS.fontSize.xs
    : DESIGN_TOKENS.fontSize.sm;
  const iconSize = isMobile ? 12 : DESIGN_TOKENS.iconSize.sm;
  const label = isMobile ? "Não Confiável" : "Cliente Não Confiável";

  return (
    <Tooltip title="Cliente não confiável - atenção especial requerida">
      <Chip
        icon={<WarningIcon sx={{ fontSize: iconSize }} />}
        label={label}
        size="small"
        sx={{
          height: chipHeight,
          fontSize,
          bgcolor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          fontWeight: 600,
          "& .MuiChip-icon": {
            color: theme.palette.error.contrastText,
          },
        }}
        aria-label="Cliente não confiável"
      />
    </Tooltip>
  );
};

export const OrderTypeChip = ({
  orderType,
  channelCode,
  theme,
  isMobile = false,
}) => {
  const getOrderTypeIcon = () => {
    if (orderType === ORDER_TYPES.DELIVERY) {
      return <LocalShippingIcon fontSize="small" />;
    }

    if (
      orderType === ORDER_TYPES.TAKEOUT ||
      orderType === ORDER_TYPES.TAKEOUT_PT
    ) {
      return <StorefrontIcon fontSize="small" />;
    }

    if (
      orderType === ORDER_TYPES.INDOOR ||
      orderType === ORDER_TYPES.INDOOR_PT
    ) {
      return <RestaurantIcon fontSize="small" />;
    }

    return <AssignmentIcon fontSize="small" />;
  };

  const chipHeight = isMobile
    ? DESIGN_TOKENS.chipHeight.sm
    : DESIGN_TOKENS.chipHeight.md;
  const fontSize = isMobile
    ? DESIGN_TOKENS.fontSize.base
    : DESIGN_TOKENS.fontSize.sm;

  return (
    <Tooltip title={`Tipo: ${orderType}`}>
      <Chip
        icon={getOrderTypeIcon()}
        label={channelCode || "N/A"}
        size="small"
        sx={{
          height: chipHeight,
          bgcolor: alpha(theme.palette.info.main, 0.1),
          color: theme.palette.info.main,
          fontWeight: 500,
          fontSize,
          "& .MuiChip-icon": {
            color: theme.palette.info.main,
          },
        }}
        aria-label={`Tipo de pedido: ${orderType}, Canal: ${channelCode}`}
      />
    </Tooltip>
  );
};

export const TotalChip = ({
  total,
  totalChipStyling,
  theme,
  isMobile = false,
}) => {
  const chipHeight = isMobile
    ? DESIGN_TOKENS.chipHeight.sm
    : DESIGN_TOKENS.chipHeight.md;
  const fontSize = isMobile
    ? DESIGN_TOKENS.fontSize.base
    : DESIGN_TOKENS.fontSize.sm;

  return (
    <Tooltip title={`Total do Pedido: ${total}`}>
      <Chip
        icon={
          <AttachMoneyOutlinedIcon
            sx={{ fontSize: DESIGN_TOKENS.iconSize.sm }}
          />
        }
        label={total}
        size="small"
        variant={totalChipStyling.variant}
        sx={{
          height: chipHeight,
          fontSize,
          "& .MuiChip-label": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
          },
          ...totalChipStyling.sx,
        }}
        aria-label={`Total do pedido: ${total}`}
      />
    </Tooltip>
  );
};
